<template>
  <el-collapse-item name="smtpd">
    <template slot="title">
      SMTP Server
      <el-tag v-if="form.smtpd === '1'" type="success" size="small">ON</el-tag>
      <el-tag v-else type="info" size="small">OFF</el-tag>
    </template>

    <el-row :gutter="20">
      <el-col :span="5">
        <el-switch
          v-model="form.smtpd"
          active-text="Enable"
          active-value="1"
          inactive-value="0"
          @change="changeDebounce"
        />
      </el-col>

      <el-col class="notice" :span="19">
        Allow this app to send emails when enabled.
      </el-col>
    </el-row>
  </el-collapse-item>
</template>

<script>
import config from '../../../../mixins/config'

export default {
  mixins: [config]
}
</script>

<style lang="scss" scoped>
  @import "../../../../theme";

  .notice {
    line-height: 15px;
    padding: 5px 0;
    font-size: 13px;
    color: $--color-text-alt;
  }
</style>
